// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + {"521":"16e75fa03e7c9f42","964":"55be2343c92ebcfd"}[chunkId] + ".js";
};